'use client';
import { useGetPromoEventData } from './useGetPromoEventData';

export const usePromoEventNeurons = () => {
	const { isResolved, data } = useGetPromoEventData();
	const neuronsOffer = data?.offers.find((offer) => offer.type === 'Neurons');
	const offersNeurons = isResolved && neuronsOffer?.buttonIconUrl;

	return {
		promoNeuronsActive: offersNeurons,
		data: {
			promocode: neuronsOffer?.promoCode,
			buttonImageUrl: neuronsOffer?.buttonIconUrl,
		},
		activeOnPages: neuronsOffer?.activeOnPages,
		isLoading: !isResolved,
	};
};
